@if (canShowSupport()) {
  <button
    #supportToggle
    mat-fab
    type="button"
    class="floating-support"
    data-cy="support-floating-button"
    matTooltip="Support"
    matTooltipPosition="right"
    [ngClass]="{ 'active': isSupportOpen() }"
    (click)="toggleSupport($event)"
  >
    <mat-icon
      class="sidebar-support"
      svgIcon="message-text"
      matBadgeSize="small"
      [matBadge]="supportUnreadCount()"
      [matBadgeHidden]="!supportUnreadCount()"
    />
  </button>
}
